// ModalFacturasPagadas.js (nombre sugerido)
import React, { Component } from 'react';
import { Modal, Table, message } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { connect } from "react-redux";


const formatCurrency = (value) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);

class ModalFacturasPagadas extends Component {
    state = {
        facturasData: [],
        loading: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible && this.props.facturasIds?.length > 0) {
            this.fetchFacturas();
        }
    }

    fetchFacturas = () => {
        this.setState({ loading: true });
        axios.post('/facturas/selectFacturasByIds', { ids: this.props.facturasIds, pagoId: this.props.pagoId }, { headers: this.props.headersToken })
            .then(res => {
                if (res.data.success === 2) {
                    this.setState({ facturasData: res.data.data });
                } else {
                    message.error(res.data.message || 'No se pudieron cargar las facturas.');
                }
            })
            .catch(err => {
                console.error(err);
                message.error('Error de red al cargar las facturas.');
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    handleDoubleClick = (facturaId) => {
        this.props.history.push("/panel/verFacturaSinOrdenDeCompra", { id: facturaId });
        this.props.onClose();
    }

    render() {
        const { visible, onClose } = this.props;

        const columns = [
            {
                title: "N° Factura",
                dataIndex: "numeroFactura",
                key: "numeroFactura",
                width: 80,
            },
            {
                title: "Código Factura",
                dataIndex: "codigoFactura",
                key: "codigoFactura",
                width: 120,
            },
            {
                title: "Proveedor",
                dataIndex: "nombreProveedor",
                key: "nombreProveedor",
                ellipsis: true,
            },
            {
                title: "Proyecto",
                dataIndex: ["proyecto", "nombre"],
                key: "proyecto",
                ellipsis: true,
            },
            {
                title: "Fecha",
                dataIndex: "fechaFactura",
                key: "fechaFactura",
                render: (value) => moment(value).format("DD/MM/YY"),
                width: 100,
            },
            {
                title: "Total",
                dataIndex: "totalPagar",
                key: "totalPagar",
                align: "right",
                render: (value) => formatCurrency(value),
                width: 150,
            },
            {
                title: "Pago",
                dataIndex: "totalPago",
                key: "totalPago",
                align: "right",
                render: (value) => value ? formatCurrency(value) : "-",
                width: 150,
            },
        ];

        return (
            <Modal
                title="Facturas Incluidas en el Pago"
                visible={visible}
                onCancel={onClose}
                footer={null}
                width={900}
            >
                <Table
                    columns={columns}
                    dataSource={this.state.facturasData}
                    loading={this.state.loading}
                    rowKey="_id"
                    size="small"
                    pagination={false}
                    onRow={(record) => ({
                        onDoubleClick: () => this.handleDoubleClick(record._id),
                    })}
                />
            </Modal>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};
export default connect(mapStateToProps)(ModalFacturasPagadas);